import { CellType } from './Game';

export interface LevelData {
  id: number;
  title?: string;
  author?: string;
  collection: string;
  matrix: CellType[][];
  limit?: number;
}

export interface Collection {
  name: string;
  levels: LevelData[];
}

export async function loadLevels(): Promise<Collection[]> {
  const fileNames = [
    'First_steps_-_Beginner.txt',
    'First_steps_-_Advanced.txt',
    'Pufiban.txt',
    'Original_remixed.txt',
    'Magic_Sokoban_1.txt',
    'Magic_Sokoban_2.txt',
    'Magic_Sokoban_3.txt',
    'Magic_Sokoban_4.txt',
    'Magic_Sokoban_5.txt',
    'Magic_Sokoban_6.txt',
    'Magic_Sokoban_7.txt',
    'Sasquatch_V.txt',
  ];

  const collections: Map<string, LevelData[]> = new Map();

    for (const fileName of fileNames) {
      const response = await fetch(`/levels/${fileName}`);
      const text = await response.text();
      const collectionName = fileName.replace('.txt', '').replace(/_/g, ' ');

      const levels: LevelData[] = [];
      const sections = text.split(/\r?\n\r?\n/).filter(s => s.trim().length > 0);

      for (const section of sections) {
        const lines = section.split('\n');
        const titleLine = lines.find(l => l.startsWith('Title:'));
        const authorLine = lines.find(l => l.startsWith('Author:'));
        const limitLine = lines.find(l => l.startsWith('Limit:'));
        const title = titleLine ? titleLine.replace('Title:', '').trim() : undefined;
        const author = authorLine ? authorLine.replace('Author:', '').trim() : undefined;
        const limit = limitLine ? parseInt(limitLine.replace('Limit:', '').trim(), 10) : undefined;
        const matrixText = lines.filter(l => !l.startsWith('Author:') && !l.startsWith('Title:') && !l.startsWith('Limit:')).join('\n');
        const matrix = parseLevel(matrixText);

        if (matrix.length > 0) {
          const levelId = levels.length + 1;
          levels.push({ id: levelId, title, author, collection: collectionName, matrix, limit });
        }
      }

    collections.set(collectionName, levels);
  }

  return Array.from(collections.entries()).map(([name, levels]) => ({
    name,
    levels,
  }));
}

function parseLevel(levelText: string): CellType[][] {
  const matrix: CellType[][] = [];
  const validChars: CellType[] = [' ', '#', '@', '+', '$', '*', '.'];

  for (const line of levelText.split('\n')) {
    if (line.trim() === '') continue;
    
    const row: CellType[] = [];
    for (const char of line) {
      if (validChars.includes(char as CellType)) {
        row.push(char as CellType);
      }
    }
    if (row.length > 0) {
      matrix.push(row);
    }
  }

  return matrix;
}

export function getLevelById(levels: LevelData[], id: number): LevelData | undefined {
  return levels.find(level => level.id === id);
}